import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SectionsColumnsWrapper = styled.div`
  display: flex;
  gap: ${Spacing.S32};
  margin-bottom: ${Spacing.S32};

  &:last-child {
    margin-bottom: 0;
  }

  & > div {
    margin-bottom: 0;
  }
`
